
<ng-container *ngFor="let tipo of tipi">
  <all-allegati-tipo-section [tipo]="tipo" [idOggetto]="idOggetto"></all-allegati-tipo-section>
</ng-container>

